module.exports = __webpack_public_path__ + "media/images/locations-8dda4c03ec6763dbd0100527f76ec748.svg";